import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowRight } from "lucide-react";
import client, { formatApiError } from "@/lib/api";
import AuthShell, { AuthField, authInputClass } from "@/components/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await client.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (ex) {
      setErr(formatApiError(ex.response?.data?.detail) || ex.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell
      testId="forgot-password-page"
      title="Forgot your password?"
      subtitle="We'll email you a link to set a new one."
      tagline="Back to the journey in a minute."
      taglineBody="Reset links are single-use and expire after one hour."
      footer={<Link to="/login" className="font-bold text-hv-teal hover:underline">Back to sign in</Link>}
    >
      {sent ? (
        <div className="text-hv-navy" data-testid="forgot-password-sent">
          If an account exists for that email, a reset link is on its way. Check your inbox and spam folder.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <AuthField icon={<Mail size={18} strokeWidth={2.4} />} label="Email">
            <input data-testid="forgot-email" type="email" required autoFocus value={email}
                   onChange={(e) => setEmail(e.target.value)} className={authInputClass} />
          </AuthField>
          {err && <div className="text-sm text-hv-coral font-bold" data-testid="forgot-error">{err}</div>}
          <button type="submit" disabled={loading} data-testid="forgot-submit"
                  className="hv-btn-primary w-full inline-flex items-center justify-center gap-2 disabled:opacity-70">
            {loading ? "…" : <>Send reset link <ArrowRight size={18} strokeWidth={2.6} /></>}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
